import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseMilestoneIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import MemoryContext from "../../../../util/MemoryContext";


class ProjectPlanPhaseMilestoneEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestone-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestone-001";

        let fk = {};
        fk["ProjectPlanPhaseUSID"] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phase_milestones",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
                "USID": this.getAttributeValue("USID"),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-001";
        payload.ShifamedMessage.ProjectPlanPhaseMilestone = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestone-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let projectPlanPhaseMilestone = {};

        projectPlanPhaseMilestone["USID"] = this.getAttributeValue("USID");
        projectPlanPhaseMilestone["Name"] = this.getAttributeValue("Name");
        projectPlanPhaseMilestone["Description"] = this.getAttributeValue("Description");
        projectPlanPhaseMilestone["ProjectPlanPhaseUSID"] = MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"];
        projectPlanPhaseMilestone["StartDatetime"] = this.getAttributeValue("StartDatetime");
        projectPlanPhaseMilestone["DueDatetime"] = this.getAttributeValue("DueDatetime");
        projectPlanPhaseMilestone["Notes"] = this.getAttributeValue("Notes");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-001";
        payload.ShifamedMessage.ProjectPlanPhaseMilestone = projectPlanPhaseMilestone;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestone-001",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-002";
        payload.ShifamedMessage.ProjectPlanPhaseMilestone = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-002",
                "idoc-response": "v1.ProjectPlanPhaseMilestone-002",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseMilestoneEnterpriseComponent;